import { ref, type Ref, type App } from "vue";
import type { AuthService, AuthState, AuthUser } from "./authService";
import type { RouteLocationNormalized } from "vue-router";

export class MockAdapter implements AuthService {
  private readonly isAuthenticated: Ref<boolean>;
  private readonly isLoading: Ref<boolean>;
  private readonly user: Ref<AuthUser | undefined>;
  private readonly error: Ref<Error | undefined>;

  constructor(_config: Record<string, never>) {
    this.isAuthenticated = ref(true);
    this.isLoading = ref(false);
    this.user = ref({
      email: "test@example.com",
      name: "Test User",
      picture: "https://via.placeholder.com/150",
      sub: "stub|123456789",
    });
    this.error = ref(undefined);
  }

  async getAccessToken(): Promise<string | undefined> {
    return "stub-access-token";
  }

  async login(_returnTo?: string): Promise<void> {
    this.isAuthenticated.value = true;
    this.isLoading.value = false;
  }

  async logout(_returnTo?: string): Promise<void> {
    this.isAuthenticated.value = false;
    this.user.value = undefined;
  }

  getState(): AuthState {
    return {
      isAuthenticated: this.isAuthenticated,
      isLoading: this.isLoading,
      user: this.user,
      error: this.error,
    };
  }

  shouldGuardRoute(_path: string): boolean {
    return false;
  }

  async handleCallback(_url?: string): Promise<void> {
    return Promise.resolve();
  }

  async checkSession(): Promise<void> {
    return Promise.resolve();
  }

  async authGuard(_to: RouteLocationNormalized): Promise<boolean> {
    return true;
  }

  install(app: App): void {
    app.config.globalProperties.$auth = this.getState();
  }

  requiresRealAuthEndpoints(): boolean {
    return false;
  }
}
